// @ts-nocheck
import angular from 'angular';
import {popup} from '@acng/frontend-discovery';

import {hasFeature} from 'acng/core/service/env.js';
import {getLocale} from 'acng/locale/model/locale.js';
import {LivecamSession} from '../model/session.js';
import {setGlobalLivecamSession} from '../context/session.js';

angular.module('livecam').directive('onswLivecamShow', [
  'User',
  '$compile',
  '$injector',
  '$translate',
  'isMobile',
  'payment',
  '$location',
  'onsOverlay',
  'Livecam',
  'sock',
  '$rootScope',
  function (
    User,
    $compile,
    $injector,
    $translate,
    isMobile,
    payment,
    $location,
    onsOverlay,
    Livecam,
    sock,
    $rootScope
  ) {
    return {
      scope: {token: '@'},
      template: `<div class="box" id="livecamOverlay">
                    <div onsw-livecam-close></div>
                    <div id="livecamPlayer" ng-style="{height: playerHeight()}"></div>
                    <div onsw-hook hookname="livecamTools" hook-data="token"></div>
                </div>`,
      link: link,
    };

    function link(scope, element) {
      const player = element.find('#livecamPlayer');
      const tools = element.find('[hookname="livecamTools"]');
      scope.playerHeight = function () {
        return `calc(100% - ${tools.outerHeight()}px)`;
      };

      let as = null;
      if ($injector.has('Actionslider')) {
        as = $injector.get('Actionslider');
        as.hide();
      }

      scope.showButtons = false;
      scope.showControls = true;

      scope.$watch('token', function (token) {
        stop();
        const session = LivecamSession.get(token);
        if (session == undefined) {
          $translate('livecam.invalidToken').then((text) => {
            popup().warn(text);
            history.back();
          });
          return;
        }

        scope.showButtons = false;
        scope.nickname = session.nickname;
        scope.session = session;
        start();
      });

      function onExit(status) {
        let location,
          message,
          openPayment = false;

        switch (status) {
          case 9:
            break;
          case 7:
            location = `/sedcard/${scope.session.nickname}`;
            if (!User.level && scope.session.type == 'free') {
              openPayment = {
                class: ['free-cam'],
                type: 'livecam.freeshow.limitReached',
              };
            } else {
              openPayment = {
                type: 'livecam.sessionExpired',
              };
            }
            break;
          case 3:
            location = `/sedcard/${scope.session.nickname}`;
            message = true;
            break;
          default:
            location = LivecamSession.prevPath || '/livecams/online';
            message = true;
        }

        // Disable Regard shop after livecam show on all whitelabels where the regard feature is disabled
        if (Date.now() - scope.session.start_at >= 1000 * 300 && !openPayment && hasFeature('regard')) {
          onsOverlay
            .create('livecamRegardOverlay', {amateur: scope.session.amateur})
            .setPositionMain()
            .open();
        }

        if (message) {
          $translate('livecam.events.status' + status, {sender: scope.session.amateur.getNickname()}).then(
            (text) => popup().warn(text)
          ); // TODO turbo boost
        }

        if (location) {
          $rootScope.$applyAsync(() => $location.url(location));
        }

        if (openPayment) {
          payment.overlay(
            openPayment.type,
            {nickname: scope.session.amateur.getNickname()},
            openPayment.class
          );
        }
      }

      function onResize() {
        if (scope.session.client) {
          scope.$apply(() => {
            scope.session.client.resize();
          });
        }
      }

      scope.$on('$destroy', () => {
        if (as) as.show();
        stop();
      });

      function stop() {
        player.empty();
        if (scope.session) {
          scope.session.client.stopStream();
          scope.session.cam.stopLoading();
          scope.session.cam.stopRunning();
          LivecamSession.remove(scope.session.sid);
          setGlobalLivecamSession(null);
        }
      }

      function onStart() {
        scope.session.cam.startRunning();
        setGlobalLivecamSession(scope.session);
        const buttons = $compile(
          '<div onsw-hook class="popup frame center closeable columns pad10" hookname="livecamTipPopup" hook-data="session" ng-show="showButtons && showControls"></div>'
        )(scope);
        buttons.on('click', (ev) => {
          ev.stopPropagation();
          ev.preventDefault();
          scope.$apply('showButtons = false');
        });
        player.children().first().append(buttons);
      }

      function onControls(hidden) {
        scope.$apply(() => (scope.showControls = !hidden));
      }

      function onTip() {
        scope.$apply('showButtons = true');
      }

      function onMessage(message) {
        if (
          !message.fromLivecam &&
          message.recipient == scope.session.amateur.id &&
          Livecam.get(scope.session.amateur.id).showType != 'voyeur'
        ) {
          scope.session.client.addUserMessage(message.body);
        }
      }

      function start() {
        let options = {
          clientContainer: player,
          sizeElement: player,
          mode: isMobile ? 'mobile' : 'desktop',
          language: getLocale(),
          alternateDesign: true,
          noProgressBar: true,
          allowFullscreen: !(User.level < 10 && scope.session.type == 'free'),
        };

        var observer = new ResizeObserver(onResize);
        observer.observe(element[0]);
        scope.$on('$destroy', () => {
          observer.unobserve(element[0]);
          sock.unregisterHandler('message.sent', onMessage);
        });
        scope.session.client.off('closed');
        scope.session.client.off('streamStarted');

        scope.session.client.on('streamStarted', onStart);
        scope.session.client.on('closed', onExit);
        scope.session.client.off('hideControls');
        scope.session.client.off('tip');
        scope.session.client.off('showChanged');
        scope.session.client.off('userMessage');

        scope.session.client.on('hideControls', onControls);
        scope.session.client.on('tip', onTip);
        scope.session.client.on('paymentRequired', function (code) {
          scope.$broadcast('LivecamShow.PaymentRequired', code);
        });
        scope.session.client.on('showChanged', function (show) {
          Livecam.get(scope.session.amateur.id).showType = show.showType;
          setGlobalLivecamSession(scope.session);
        });
        scope.session.client.on('userMessage', function (message) {
          sock.publish('message.sent', {
            recipient: `${scope.session.amateur.id}`,
            sender: `${User.id}`,
            body: `${message}`,
            time: Date.now(),
            isMine: true,
            payload: {},
            attachment: null,
            fromLivecam: true,
          });
        });

        sock.registerHandler('message.sent', onMessage);

        scope.session.client.init(options);
        console.log({sessionId: scope.token, host: scope.session.host});
        scope.session.client.startStream({sessionId: scope.token, host: scope.session.host});
      }
    }
  },
]);
